module.exports = __webpack_public_path__ + "static/media/how-it-works-erhalten.f3747a93.png";